{
  "name": "taas-admin-frontend",
  "version": "0.3.7",
  "scripts": {
    "ng": "ng",
    "lint": "ng lint",
    "test": "ng test",
    "test:coverage": "ng test --coverage",
    "test:browser": "ng test --watch=false --browsers=ChromiumHeadless --include='src/app/features/announcements/**/*.component.spec.ts'",
    "start": "ng serve",
    "start-prod": "ng serve --configuration production",
    "start-preprod": "ng serve --configuration preprod",
    "start-de": "ng serve --configuration=de",
    "start-en": "ng serve --configuration=en",
    "start-se": "ng serve --configuration=se",
    "translate": "ng extract-i18n",
    "build": "ng build",
    "build:stats": "ng build --stats-json && esbuild-visualizer --metadata ./dist/taas-admin-frontend/stats.json --filename ./dist/taas-admin-frontend/stats.html && open-cli ./dist/taas-admin-frontend/stats.html",
    "build-prod": "ng build --configuration production",
    "build-preprod": "ng build --configuration preprod",
    "build-dev": "ng build --configuration development",
    "watch": "ng build --watch --configuration development"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.2.1",
    "@angular/common": "^21.2.1",
    "@angular/compiler": "^21.2.1",
    "@angular/core": "^21.2.1",
    "@angular/forms": "^21.2.1",
    "@angular/platform-browser": "^21.2.1",
    "@angular/platform-browser-dynamic": "^21.2.1",
    "@angular/router": "^21.2.1",
    "@material-icons/svg": "1.0.33",
    "jwt-decode": "^4.0.0",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^26.1.0",
    "tslib": "^2.8.1",
    "utimaco-common-ui-angular": "https://repo.fra1.us.utimaco.cloud/repository/npm-hosted/utimaco-common-ui-angular/-/utimaco-common-ui-angular-1.27.2.tgz",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.3.1",
    "@angular-devkit/build-angular": "^21.2.1",
    "@angular-eslint/builder": "^21.3.0",
    "@angular-eslint/eslint-plugin": "^21.3.0",
    "@angular-eslint/eslint-plugin-template": "^21.3.0",
    "@angular-eslint/schematics": "^21.3.0",
    "@angular-eslint/template-parser": "^21.3.0",
    "@angular/build": "^21.2.1",
    "@angular/cli": "^21.2.1",
    "@angular/compiler-cli": "^21.2.1",
    "@angular/localize": "^21.2.1",
    "@typescript-eslint/eslint-plugin": "^8.56.1",
    "@typescript-eslint/parser": "^8.56.1",
    "@vitest/browser-playwright": "4.1.4",
    "@vitest/coverage-v8": "^4.1.0",
    "@vitest/ui": "^4.1.0",
    "angular-eslint": "^21.3.0",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.0.0",
    "jsdom": "^29.0.1",
    "ng-extract-i18n-merge": "^3.3.0",
    "open-cli": "^9.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.56.1",
    "vitest": "^4.1.0"
  }
}
